module.exports = __webpack_public_path__ + "static/media/collection-icon-empty.c77728f0.svg";